export default __webpack_public_path__ + "static/media/preloader.c4323b89.gif";